import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined } from 'faro-common-model';
import { toNamedObject } from './named-object.js';
import { StudyEntityType } from './study-entity-type.js';
export const objectiveGroupTypeMaxLength = 250;
export function toObjectiveGroup(objectiveGroup) {
    checkDefined(objectiveGroup.type, 'ObjectiveGroup', 'type');
    checkDefined(objectiveGroup.objectiveIds, 'ObjectiveGroup', 'objectiveIds');
    return {
        ...toBaseStudyEntity(objectiveGroup, StudyEntityType.ObjectiveGroup),
        type: toNamedObject(objectiveGroup.type),
        objectiveIds: [...objectiveGroup.objectiveIds],
        showEstimands: objectiveGroup.showEstimands || false,
    };
}
//# sourceMappingURL=objective-group.js.map